module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Grand Prime Gold.d940dfd0.png";